// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__Z8PUO","inner":"Header_inner__tfr0u","title":"Header_title__Otn70","nav_area":"Header_nav_area__6KVpk"};